A list of currencies.

These may be presented to a hirer for selection in a job posting flow.
A dropdown is recommended.

This query accepts browser tokens that include the `query:ontologies` or `query:enhanced-job-posting` scope.
